import { Component, h, Prop } from '@stencil/core';
import { ButtonOptions, ButtonSize, ButtonType } from './button.interface';
import { IconUIType, ValueOfIconUIType } from '../icon/icon-ui-type';
import { applyOptions } from '../../../utils';

@Component({
    tag: 'web-button',
    styleUrl: 'buttons.scss',
    shadow: false
})
export class Button implements ButtonOptions {
    @Prop() buttonText: string;
    @Prop() linkTitle: string;
    @Prop() type = ButtonType.primary;
    @Prop() size = ButtonSize.large;
    @Prop() fullWidth = false;
    @Prop() disabled = false;
    @Prop() iconStart: ValueOfIconUIType = IconUIType.none;
    @Prop() iconEnd: ValueOfIconUIType = IconUIType.none;

    /**
     * The options for this component
     */
    @Prop() options: ButtonOptions | string;

    private classNames = {};

    componentWillLoad() {
        applyOptions(this);
        this.classNames = {
            button: true,
            'button-primary': this.type === 'primary',
            'button-secondary': this.type === 'secondary',
            'button-plain': this.type === 'plain',
            'button-large': this.size === 'large',
            'button-small': this.size === 'small',
            'button-extra-small': this.size === 'extra-small',
            'button-full-width': this.fullWidth
        };
    }

    private onButtonClick = (event: Event) => {
        (event.currentTarget as HTMLElement).blur();
    };

    render() {
        return (
            <button
                class={this.classNames}
                onClick={this.onButtonClick}
                disabled={this.disabled}
                title={this.linkTitle || undefined}
            >
                {this.iconStart && <web-icon class="icon-start" name={this.iconStart}></web-icon>}
                {this.buttonText ?? <slot></slot>}
                {this.iconEnd && <web-icon class="icon-end" name={this.iconEnd}></web-icon>}
            </button>
        );
    }
}
